<div>
  <table
    mat-table
    [appTableConfig]="'SELECT'"
    [dataSource]="dataSource"
    multiTemplateDataRows
    matSort
    (matSortChange)="onSortChange($event)"
  >
    <ng-container [matColumnDef]="COLUMNS_ID.SELECT">
      <th mat-header-cell *matHeaderCellDef>
        @if(selectionEnabled){
        <mat-checkbox
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
        >
        </mat-checkbox>
        }
      </th>
      <td mat-cell *matCellDef="let row" class="visible">
        @if(selectionEnabled){
        <mat-checkbox
          *ngIf="row.canSelect && !row.isRow"
          (click)="$event.stopPropagation()"
          (change)="onChangeCheckbox($event, row)"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
        >
        </mat-checkbox>
        }
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.CERTIF">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div id="icons">
          <app-certification-badge
            [prop]="row"
            [size]="'SMALL'"
            [class.separator]="row.certified"
          ></app-certification-badge>
          <ul class="row-list">
            <!-- shared -->
            <li>
              <mat-icon
                color="accent"
                [appTooltip]="row.typeName"
                class="small-icon"
                >{{ row.typeIcon }}</mat-icon
              >
            </li>
            <li *ngIf="row.isSharedProperty && row.canUpdate">
              <mat-icon
                color="accent"
                appTooltip="Droits d'accès en délégation sur le bien"
                class="small-icon"
                >vpn_key</mat-icon
              >
            </li>
            <li *ngIf="row.isOnSelling">
              <mat-icon
                color="accent"
                appTooltip="Bien en vente"
                class="small-icon"
                >real_estate_agent</mat-icon
              >
            </li>
            <li *ngIf="row.demo">
              <mat-icon
                appTooltip="Bien de démonstration"
                class="small-icon demo-icon"
                >circle</mat-icon
              >
            </li>
          </ul>
        </div>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.PHOTO">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="head-img">
        <!--<a *ngIf="!row.isRow" appTooltip="Afficher les détails" (click)="onClickViewdetails(row)">
          <app-img-display [type]="'propertyPhoto'" [uid]="row.uid" [imageTs]="row.mainPhotoTs"
            [size]="'110x62'"></app-img-display>
        </a>-->
        <a
          *ngIf="!row.isRow"
          [routerLink]="row.routerLink"
          appTooltip="Voir le bien"
        >
          <app-img-display
            [type]="'propertyPhoto'"
            [uid]="row.uid"
            [imageTs]="row.mainPhotoTs"
            [size]="'110x62'"
          ></app-img-display>
        </a>
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.NAME">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
      <td
        mat-cell
        *matCellDef="let row"
        class="main head-1 visible"
        [attr.colspan]="row.isRow ? displayedColumns.length : 1"
      >
        @if (!row.isRow) {
        <a class="link" [routerLink]="row.routerLink" appTooltip="Voir le bien">
          <mat-icon *ngIf="row.hasParent" class="align-bottom"
            >subdirectory_arrow_right</mat-icon
          >
          {{ row.name
          }}{{
            row.onGoingSelling
              ? " - " +
                ("enum.SellingStatus." + row.onGoingSelling.status | translate)
              : ""
          }}
        </a>
        } @if (row.isRow && !row.rowActionId) {
        {{ row.name }}
        } @if (row.isRow && row.rowActionId) {
        <button
          type="button"
          mat-flat-button
          color="primary"
          class="m-2"
          (click)="triggerRowAction(row.rowActionId)"
          [disabled]="row.rowLoading"
        >
          <ng-container *ngIf="row.rowLoading; else text">
            <mat-icon>
              <mat-spinner diameter="20"> </mat-spinner>
            </mat-icon> </ng-container
          ><ng-template #text>{{ row.name }}</ng-template>
        </button>
        }
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.TYPE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let row" class="head-2">
        {{ "enum.PropertyType." + row.type | translate }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.SALE_STATUS">
      <th mat-header-cell *matHeaderCellDef>Statut vente</th>
      <td mat-cell *matCellDef="let row" class="head-3">
        {{ row.saleStatusDisplay }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.NUM">
      <th mat-header-cell *matHeaderCellDef>Lot</th>
      <td mat-cell *matCellDef="let row">
        {{ row.num }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.FLOOR">
      <th mat-header-cell *matHeaderCellDef>Étage</th>
      <td mat-cell *matCellDef="let row" class="no-mobile">
        {{ row.floor }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.OWNER_NAME">
      <th mat-header-cell *matHeaderCellDef>Propriétaire</th>
      <td mat-cell *matCellDef="let row">
        {{ row.ownerDisplay }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.SHARED_BY_NAME">
      <th mat-header-cell *matHeaderCellDef>Partagé par</th>
      <td mat-cell *matCellDef="let row">
        {{ row.sharedByDisplay }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.CITY">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
      <td mat-cell *matCellDef="let row" class="head-3">
        {{ row.city }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.CERTIFICATION">
      <th mat-header-cell *matHeaderCellDef>Certification</th>
      <td mat-cell *matCellDef="let row">
        {{ "enum.CertificationType." + row.certificationDisplay | translate }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.EEMO_ID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>EemoId</th>
      <td mat-cell *matCellDef="let row">
        {{ row.eemoId }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.CHILDREN">
      <th mat-header-cell *matHeaderCellDef>Biens liés</th>
      <td mat-cell *matCellDef="let row" class="no-mobile">
        {{ row?.children?.length }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.SELLING_PRICE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Prix</th>
      <td mat-cell *matCellDef="let row">
        {{ row.sellingPrice | currency : "EUR" : "symbol" : "1.0" }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.DATE_CREATE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Créé le</th>
      <td mat-cell *matCellDef="let row">
        {{ row.dateCreate | dateFormat }}
      </td>
    </ng-container>
    <ng-container [matColumnDef]="COLUMNS_ID.ACTIONS">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row" class="mobile-double-actions">
        <button
          *ngIf="!archiveMode"
          mat-icon-button
          [appTooltip]="
            row.isFavorite ? 'Supprimer des favoris' : 'Ajouter au favoris'
          "
          (click)="toogleFavorite(row)"
        >
          <mat-icon color="primary">{{
            row.isFavorite ? "favorite" : "favorite_border"
          }}</mat-icon>
        </button>
        <button
          mat-icon-button
          [matMenuTriggerFor]="actions"
          [matMenuTriggerData]="{ data: row }"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row">
        <div
          class="element-detail row"
          [@detailExpand]="
            row === expandedElement ? onExpandedRow(row) : 'collapsed'
          "
        >
          <app-property-details
            *ngIf="row.uid && row.alreadyBeenLoaded"
            [property]="row"
            [highestAncestor]="propParentId"
            [condoMode]="condoMode"
          ></app-property-details>
        </div>
        <app-more-details
          (needOpen)="
            expandedElement = expandedElement === row ? null : row;
            loadPropertyDetails(row.uid)
          "
        ></app-more-details>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.expanded-row]="expandedElement === row"
      class="with-detail theme-1"
      [class.is-row]="row.isRow"
      [class.is-row-action]="row.rowActionId"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      [appDetailRow]="'SELECT'"
    ></tr>

    <tr *matNoDataRow>
      <td [attr.colspan]="displayedColumns.length">
        <span class="no-content">{{ noDataText }}</span>
      </td>
    </tr>
  </table>

  <div class="loading" *ngIf="isLoading">
    <app-data-loading></app-data-loading>
  </div>

  <mat-menu #actions="matMenu">
    <ng-template matMenuContent let-row="data">
      <ul class="menu-actions">
        <li>
          <a
            (click)="
              expandedElement = expandedElement === row ? null : row;
              loadPropertyDetails(row.uid)
            "
          >
            <mat-icon color="primary">info</mat-icon>
            <span class="text">Afficher les détails</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/property', row.uid]">
            <mat-icon color="primary">remove_red_eye</mat-icon>
            <span class="text">Voir le bien</span>
          </a>
        </li>
        <li>
          <a *ngIf="condoMode" (click)="addChild(row)">
            <mat-icon color="primary">add</mat-icon>
            <span class="text">Ajouter un bien lié</span>
          </a>
        </li>
        <li>
          <a *ngIf="condoMode" (click)="clone(row)">
            <mat-icon color="primary">content_copy</mat-icon>
            <span class="text">Cloner le bien</span>
          </a>
        </li>
        <li>
          <a *ngIf="row.canAddShare" (click)="addShare(row)">
            <mat-icon color="primary">share</mat-icon>
            <span class="text">Partager le bien</span>
          </a>
        </li>
        <li *ngIf="row.certified">
          <a (click)="actionService.copyPropNfcUrl(row)"
            ><mat-icon color="primary">content_copy</mat-icon
            ><span class="text">Copier le lien du bien</span></a
          >
        </li>
        <li>
          <a *ngIf="row.canCertify" (click)="certify(row)">
            <mat-icon color="primary">{{
              row.certified ? "update" : "check_circle_outline"
            }}</mat-icon>
            <span class="text">{{
              row.certified
                ? "Renouveler la certification"
                : "Certifier le bien"
            }}</span>
          </a>
        </li>
        <li>
          <a *ngIf="row.canTransfert" (click)="transfertOwnership(row)">
            <mat-icon color="primary">transfer_within_a_station</mat-icon>
            <span class="text">Transférer la propriété</span>
          </a>
        </li>
        <li>
          <a *ngIf="row.canArchive" (click)="togglePropertyArchive(row)">
            <mat-icon color="primary">{{
              row.archived ? "unarchive" : "archive"
            }}</mat-icon>
            <span class="text"
              >{{ row.archived ? "Désarchiver" : "Archiver" }} le bien</span
            >
          </a>
        </li>
        <li>
          <a *ngIf="row.canDelete" (click)="confirmDeleteProperty(row)">
            <mat-icon color="primary">delete_forever</mat-icon>
            <span class="text">Supprimer le bien</span>
          </a>
        </li>
      </ul>
    </ng-template>
  </mat-menu>
</div>
